import * as Redux from 'redux'
import * as IsActive from '../../../components/is_active'
import * as Modal from '../../../components/modal'
import * as Request from '../../../request'
import * as SourceConstants from '../constants'
import * as SourceTypes from '../types'
import * as Constants from './constants'
import * as Types from './types'
import * as Utils from './utils'

export type ModalPopulator = (filterType: Types.FilterType, sourceType: Types.SourceType) => Redux.Action

export const modalPopulator: ModalPopulator =
  (filterType: Types.FilterType, sourceType: Types.SourceType) =>
    ({type: Modal.toggleModalConstant(Utils.toggleModalEvent(filterType, sourceType))})

export const toggleModal: Modal.Toggle = Modal.toggleModal(Constants.ADD_FILTERS)
export const updateModalField: Modal.Update = Modal.updateModal(Constants.ADD_FILTERS)

interface FetchFilterPayload
  extends Request.RequestOptions { sourceId: SourceTypes.SourceId}

export const fetchFilters = (community: string, sourceId: SourceTypes.SourceId) =>
  Request.requestActionCreator<FetchFilterPayload>(Constants.FETCH_FILTERS)({
    method: 'GET',
    sourceId,
    url: `${SourceConstants.SERVER_RESOURCE}/${community}/${sourceId}/filters`,
})

export type SubmitFilterModal =
  (community: string, subscriptionId: SourceTypes.SourceId, data: Types.AddFilterData) => Redux.Action

export const createFilters: SubmitFilterModal =
  (communityIdentifier: string, subscriptionId: SourceTypes.SourceId, data: Types.AddFilterData) =>
  Request.requestActionCreator(Constants.ADD_FILTERS)({
    method: 'POST',
    payload: data,
    url: `${SourceConstants.SERVER_RESOURCE}/${communityIdentifier}/${subscriptionId}/filters`,
  })

export const updateFilter = (communityIdentifier: string, stateChange: IsActive.StateChange) =>
  Request.requestActionCreator(Constants.UPDATE_FILTER)({
    method: 'PUT',
    payload: IsActive.asUpdateBody(stateChange),
    url: `${SourceConstants.SERVER_RESOURCE}/${communityIdentifier}/filters/${stateChange.id}`,
  })



// WEBPACK FOOTER //
// ./src/pages/source-config/filters/actions.ts